// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__y_kF7","bordered":"Checkbox_bordered__3NRPx","checked":"Checkbox_checked___3zi_"};